export default {
    url: '/users',
    template: '<manage-permissions-roles-detail-users role="vm.role"/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/permissions/roles/detail/users/index.js